import React from 'react'
import {Helmet} from "react-helmet";
import AnaSponsorCard from '../../../sponsorcard/AnaSponsorCard'
import PageTitle from '../../../pagetitle/PageTitle'

export default function AnaSponsorlar()
{
    const title = "OKAF Ana Sponsorlar - Samsun Üniversitesi";
    const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'ın ana sponsorlarına ulaşmak için tıklayınız!";
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <PageTitle name="Ana Sponsorlar"></PageTitle>
            { <AnaSponsorCard /> }
        </>
    )
}
